import { useInView } from '@/hooks/useInView';

const logos = [
  { src: 'https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/arduino-logo.svg', alt: 'Arduino' },
  { src: 'https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/scratch-logo.svg', alt: 'Scratch' },
  { src: 'https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/c-lang-logo.svg', alt: 'C Language' },
  { src: 'https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/autodesk-tinkercad-logo.svg', alt: 'Tinkercad' },
];

const features = [
  'A million-strong community of developers',
  "Adult technologies in children's robot KIT",
  'Best for creativity and prototyping.',
];

export default function OpenSourceSection() {
  const { ref, inView } = useInView();

  return (
    <section id="robot" ref={ref as React.RefObject<HTMLElement>} className="bg-gray-50 py-24 px-6">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-14">
        <div className={`flex-1 transition-all duration-700 ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">Open Source</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne mb-4">
            Open source programmable robot
          </h2>
          <p className="text-gray-500 mb-8 text-sm">Scratch and C through Arduino IDE, ESP IDE, Tinkercad.</p>
          <div className="flex flex-col gap-4">
            {features.map((f) => (
              <div key={f} className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-yellow-400 text-xl"></i>
                </div>
                <span className="text-sm font-medium text-gray-700">{f}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={`flex-1 grid grid-cols-2 gap-4 transition-all duration-700 delay-150 ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
          {logos.map((logo) => (
            <div key={logo.alt} className="bg-white rounded-2xl p-6 flex items-center justify-center h-24 border border-gray-100 hover:border-yellow-300 transition-colors">
              <img src={logo.src} alt={logo.alt} className="max-h-10 max-w-full object-contain" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
